'use client';
import dynamic from 'next/dynamic';
import HireProcess from '@/components/technologies/hire-process';
import CaseStudies from '@/components/common/case-study-section';
import ClientTestimonials from '@/components/home/client-testimonials';
import WhyChooseUs from '@/components/technologies/why-choose-us';
import DefaultBreadcrumb from '@/components/common/breadcrumbs';
import CakePhpServies from '@/components/technologies/cakephp-demand';
import YiiModelsOfWorking from '@/components/technologies/yii-models-of-working';
import MetaTags from '@/components/meta-tag/meta-tag';
import Blog from '@/components/home/blog';

const ContactInfo = dynamic(() => import('@/components/common/contact-info'));
const ContactForm = dynamic(() => import('@/components/common/contact-form'));

const TechHero = dynamic(() => import('@/components/technologies/tech-hero'));
const ContetVideoSection = dynamic(() => import('@/components/common/content-video'));
const Page = () => {
    return (
        <>
            <MetaTags />
            <TechHero
                className=""
                desc="Drive Your Business Ahead with High-End Yet Cost-Effective CakePHP Web Application Development!"
                alt="CakePHP Development"
                title="CakePHP Development"
                width={1090}
                height={604}
                path={'cake-php-hero'}
                bgPath={'hero-bg-grunge'}
            >
                CakePHP Development
            </TechHero>

            <DefaultBreadcrumb parentPage="Technologies" isParent={true} currentPage="CakePHP Development" />
            <ContetVideoSection title="Build Scalable, Smart & Flexible CakePHP Solutions">
                <>
                    <p className="fw-400 text-secondary fs-md">
                        Being a leading website framework to develop robust solutions, CakePHP helps you to build powerful and
                        swift solutions and Moweb helps you to get the best out of it. Working since more than a decade, we excel
                        in the development of highly scalable and versatile CakePHP website solutions for multiple niche. Be it
                        business, retail, education or any other, we had it all.
                    </p>
                    <p className="fw-400 text-secondary fs-md">
                        Moweb is a one-stop CakePHP development company that caters you with the best CakePHP development
                        services. Our wide array of services aids you to build a solution that supports major database systems
                        like Oracle, MySQL, PostgreSQL and others. So, whether you want to integrate existing data with modern
                        CakePHP solutions or want to develop plugins, we can assist you in all terms. Just drop us your details at
                        sales@moweb.com and we will get in touch to you soon.
                    </p>
                </>
            </ContetVideoSection>
            <CakePhpServies />
            <HireProcess
                bg="bg-cakephp"
                pageTitle="Hire Custom CakePHP Developers To Build Cutting-Edge Digital Products"
                desc="Get a free consultation from our experts who will brainstorm your project idea to convert it into an advanced digital product using CakePHP ."
            />
            <WhyChooseUs pageTitle="Why Clients Choose Moweb for CakePHP Consulting?" />
            <YiiModelsOfWorking
                title="Engagement models to hire the best CakePHP Developers"
                desc="Select from different engagement models to hire CakePHP Developers for your business needs. Different types of engagements allow you to find an optimal match for your company’s specific needs; whether that means hiring expert developers, or being flexible enough to change when necessary."
            />
            <CaseStudies />
            <section className="">
                <ClientTestimonials />
            </section>
            <Blog />
            <div className="section bg-primary py-100 dark:text-light dark:bg-black">
                <div className="container lg:container md:mx-auto">
                    <div className="row grid md:grid-cols-12 lg:grid-cols-12">
                        <ContactForm />
                        <ContactInfo />
                    </div>
                </div>
            </div>
        </>
    );
};

export default Page;
